<script setup lang="ts">
import type { DartsThrow } from '~/stores/localGameStore'

const props = defineProps<{
  dartsThrows: DartsThrow[]
  correctingScore: DartsThrow | null
  startingScore: number
  onScoreTap: (dartsThrow: DartsThrow) => void
  canCorrectScore: boolean
  viewOnly?: boolean
}>()

const start = (playerThrow: DartsThrow) => {
  if (props.canCorrectScore && !props.viewOnly) {
    const lastThrow = props.dartsThrows[props.dartsThrows.length - 1]
    if (lastThrow && lastThrow.ulid === playerThrow.ulid) {
      props.onScoreTap(playerThrow)
    }
  }
}

const remainingScoreAfterThrow = function (index: number) {
  const throws = props.dartsThrows.slice(0, index + 1).reduce((acc, throwItem) => {
    return acc + throwItem.s
  }, 0)
  return props.startingScore - throws
}
</script>

<template>
  <component
    :is="viewOnly ? 'div' : 'button'"
    v-for="(playerThrow, index) in dartsThrows"
    :key="playerThrow.ulid + '-throw'"
    v-touch:tap.prevent="() => start(playerThrow)"
    class="relative text-[7vw] sm:text-[5.5vw] portrait:sm:text-[8vw] grid grid-cols-2 divide-x border-b"
    :class="{
      'bg-orange-400': playerThrow.ulid === correctingScore?.ulid,
    }"
  >
    <span>
      {{ playerThrow.s }}
    </span>
    <span>
      {{ remainingScoreAfterThrow(index) }}
    </span>
  </component>
</template>
